<div>
    <div style="float:left;width:70px"><b><i><a [routerLink]="['../../profile',{'showCategory':true}]">Terug</a></i></b></div>
    <div style="float:left;width:65%"><h2><i>{{categoryname}}</i></h2></div>
    <div style="float:left;width:70px" (click)="deleteCategory(id)"><b><i>Verwijder</i></b></div>
</div>
<hr style="text-align:center;width:90%">
